import {httpUrl} from './httpUrl'

// let baseUrl = `${httpUrl.host}/kj-gy-apartment`
// let baseUrl85 = `${httpUrl.host}/kj-gy-apartment`
let baseUrl = `${httpUrl.host}/gy-finance`
let baseUrl85 = `${httpUrl.host}/gy-apartment`

let api = {
  // 开票数据
  getStatistics: `${baseUrl}/invoiceOverview/getStatistics`,

  // 开票统计
  getInvoiceStatistics: `${baseUrl}/invoiceOverview/getInvoiceStatistics`,

  // 开票次数
  getInvoicingCount: `${baseUrl}/invoiceOverview/invoicingCount`,

  // 开票金额
  getInvoicingMoney: `${baseUrl}/invoiceOverview/invoicingMoney`,

  // 销方管理——分页
  getResellerConfigurationPage: `${baseUrl}/resellerConfiguration/getPage`,

  // 销方管理——添加
  addResellerConfiguration: `${baseUrl}/resellerConfiguration/add`,

  // 销方管理——详情
  getResellerConfigurationByCode: `${baseUrl}/resellerConfiguration/getByCode`,

  // 销方管理——修改
  updateResellerConfiguration: `${baseUrl}/resellerConfiguration/update`,

  // 销方管理——删除
  deleteResellerConfigurationByCodes: `${baseUrl}/resellerConfiguration/deleteByIds`,

  // 查询关联账单
  getRelatedRecordList: `${baseUrl}/invoiceRecord/getRelatedRecordList`,

  // 作废
  invalidInvoice: `${baseUrl}/invoiceRecord/invalidInvoice`,

  // 普通发票红冲
  redInvoice: `${baseUrl}/invoiceRecord/redInvoice`,

  // 红冲申请
  redInvoiceApply: `${baseUrl}/invoiceRecord/redInvoiceApply`,

  // 重新开票
  resetInvoice: `${baseUrl}/invoiceRecord/resetInvoice`,

  // 同步
  syncInvoice: `${baseUrl}/invoiceRecord/syncInvoice`,

  // 查询缴费列表
  getInvoiceItemList: `${baseUrl}/invoiceItemConfiguration/getItemList`,

  // 查询税率分页
  getInvoiceTaxRatePage: `${baseUrl}/invoiceItemConfiguration/getPage`,

  // 添加税率
  addInvoiceTaxRate: `${baseUrl}/invoiceItemConfiguration/add`,

  // 查询税率
  getInvoiceTaxRateByCode: `${baseUrl}/invoiceItemConfiguration/getByCode`,

  // 修改税率
  updateInvoiceTaxRate: `${baseUrl}/invoiceItemConfiguration/update`,

  // 删除税率
  deleteInvoiceTaxRateByCodes: `${baseUrl}/invoiceItemConfiguration/deleteByCodes`,

  // 发票抬头——分页
  getInvoiceTitlePage: `${baseUrl}/invoiceTitle/getPage`,

  // 发票抬头——添加
  addInvoiceTitle: `${baseUrl}/invoiceTitle/add`,

  // 发票抬头——详情
  getInvoiceTitleByCode: `${baseUrl}/invoiceTitle/getByCode`,

  // 发票抬头——修改
  updateInvoiceTitle: `${baseUrl}/invoiceTitle/update`,

  // 发票抬头——删除
  deleteInvoiceTitleByCodes: `${baseUrl}/invoiceTitle/deleteByCodes`,

  // 发票抬头——列表
  getInvoiceTitleList: `${baseUrl}/invoiceTitle/list`,

  // 发票抬头——天眼查
  getTycEnterprise: `${baseUrl85}/enterpriseInfo/getTycEnterprise`,

  // 查询销方配置
  getConfiguration: `${baseUrl}/resellerConfiguration/get`,

  // 修改销方配置
  saveOrUpdateConfiguration: `${baseUrl}/resellerConfiguration/saveOrUpdate`,

  // 查询消息接收人
  getMessageReceiverPersonList: `${baseUrl}/messageReceiver/getList`,

  // 修改消息接收人
  reselectReceiverMessageReceiverPersonList: `${baseUrl}/messageReceiver/reselectReceiver`,

  // 消息接收人
  getResponsiblePersonList: `${baseUrl85}/person/getResponsiblePersonList`,

  // 发票管理——查询开票对象
  getMainBodyList: `${baseUrl}/totalBill/mainBodyList`,

  // 发票管理——根据开票对象查询账单
  getInvoiceListByMainBody: `${baseUrl}/totalBill/invoiceList`,

  // 发票管理——收款记录
  getInvoicingPage: `${baseUrl}/invoicing/getPage`,

  // 发票管理——开票
  openInvoice: `${baseUrl}/invoicing/openInvoice`,

  // 发票管理——查询默认配置
  defaultRemark: `${baseUrl}/invoicing/defaultRemark`,

  // 发票管理——开票记录
  getInvoiceRecordPage: `${baseUrl}/invoiceRecord/getPage`,

  // 发票管理——开票详情
  getInvoiceRecordBySerialNo: `${baseUrl}/invoiceRecord/getBySerialNo`,

  // 收据管理——收款记录
  getDepositBillPage: `${baseUrl}/depositBill/getPage`,

  // 收据管理——根据开票对象查询账单
  getReciptListByMainBody: `${baseUrl}/totalBill/reciptList`,

  // 收据管理——查询默认配置
  getIssuer: `${baseUrl}/receiptRecord/getIssuer`,

  // 收据管理——收据套打
  printDepositBillReceipt: `${baseUrl}/depositBill/printReceipt`,

  // 收据管理——开票记录
  getReceiptRecordPage: `${baseUrl}/receiptRecord/getPage`,

  // 收据管理——查询主体列表
  getEnterpriseList: `${baseUrl}/chargeBill/enterpriseList`,

  // 收据管理——查询收费项列表
  getPaymentItemList: `${baseUrl}/paymentItem/getList`,

  // 收据管理——计算汇总金额
  calculateTotalAmount: `${baseUrl}/chargeBill/calculateTotalAmount`,

  // 收据管理——汇总开票
  collectReceiptReceiptRecord: `${baseUrl}/receiptRecord/collectReceipt`,

  // 查询开票类型配置
  getInvoiceTypeConfig: `${baseUrl}/invoiceType/getConfig`,

  // 修改开票类型配置
  updateInvoiceTypeConfig: `${baseUrl}/invoiceType/save`,

  // 获取协议分页
  getReceiptTemplateList: `${baseUrl}/receiptTemplate/getList`,

  // 创建收据模板
  createReceiptTemplate: `${baseUrl}/receiptTemplate/createNoticeUrl`,


  // 备注管理--查询取值
  getValueList: `${baseUrl}/invoiceMemoDict/getPage`,

  // 备注管理--查询备注
  getRemarkList: `${baseUrl}/invoiceMemoConfig/getPage`,

  // 备注管理--删除备注
  deleteRemark: `${baseUrl}/invoiceMemoConfig/deleteByCodes`,

  // 备注管理--添加取值
  addValue: `${baseUrl}/invoiceMemoDict/add`,

  // 备注管理--添加备注
  addRemark: `${baseUrl}/invoiceMemoConfig/add`,

  // 备注管理--查询可复制取值字段
  getCopyValueList: `${baseUrl}/invoiceMemoDict/getList`,

  // 导出开票记录
  exportInvoiceRecord: `${baseUrl}/invoiceRecord/export`,

  // 查询开票项
  getInvoiceRecordItem: `${baseUrl}/invoiceRecord/getInvoiceItem`,

  // 重新开票
  reInvoicing: `${baseUrl}/invoicing/restart`,

  // 发票管理--查询备注列表
  getInvoiceRemarkList: `${baseUrl}/invoiceMemoConfig/getList`,

  // 发票管理--查询备注类型查看开票备注
  getInvoiceRemark: `${baseUrl}/invoiceMemoConfig/obtainRemark`,
}

export {api}



// WEBPACK FOOTER //
// ./src/view/api/invoice.js